import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../model/widget.model';

@Component({
    selector: 'app-etf-contract-filter-widget',
    templateUrl: './etf-contract-filter-widget.component.html',
    styleUrl: './etf-contract-filter-widget.component.scss',
})
export class AppEtfContractFilterWidgetComponent {
    @Input() widgetData: WidgetModel;
}